import type { MigrationStrategies } from "./_types/migration-strategies";

export const EXCHANGE_RATE_MIGRATION_STRATEGIES: MigrationStrategies = {};
